/**
 * InputCheckBox component
 * @returns <InputCheckBox />
 */
import { useEffect, useState } from "react"

const InputCheckBox = (props) => {
  const {
    type,
    id,
    name,
    value,
    label,
    isRequired,
    extraClass,
    isChecked,
    changed,
    color,
    clicked,
    disabled,
    error
  } = props;

  // Checkbox
  if (type === "checkbox") {
    return (
      <div className="input">
        <div className={`input__field --checkbox ${extraClass ? extraClass : ""}`}>
          <input className={`input__checkbox`} type="checkbox" name={name} required={isRequired ? true : false} value={value} id={id} checked={isChecked} onChange={changed} onClick={clicked} disabled={disabled} />
          <label htmlFor={name} className={`input__checkbox__label`}>{label}</label>
        </div>

        {/* Message box to display a message 
            types: ok, error
        */}
        {/* <div className="input__message">
          <img src={imageSrc} alt="" />

          <p>Hubo un error</p>
        </div> */}
      </div>
    )
  }

  // Toggle
  if (type === "toggle") {
    return (
      <div className="input">
        <div className={`input__field --checkbox --toggle ${extraClass ? extraClass : ""} ${error ? "is-invalid" : ""}`}>
          <input className={`input__toggle`} type="checkbox" name={name} required={isRequired ? true : false} value={value} id={id} onChange={changed} checked={isChecked} />
          <div className="toggle-switch"></div>
          <label htmlFor={name} className={`input__toggle__label`}>{label}</label>
        </div>

        {/* Message box to display a message 
            types: ok, error
        */}
        {/* <div className="input__message">
          <img src={imageSrc} alt="" />

          <p>Hubo un error</p>
        </div> */}
      </div>
    )
  }

  // Toggle with background
  if (type === "toggle-box") {
    return (
      <div className="input">
        <div className={`input__field --checkbox --toggle --box ${disabled ? "--disabled" : ""}`}>
          <input className={`input__toggle`} type="checkbox" name={name} required={isRequired ? true : false} value={value} id={id} onChange={changed} />
          <label htmlFor={name} className={`input__toggle__label`}>{label}</label>
          <div className="toggle-switch" onClick={changed}></div>
        </div>

        {/* Message box to display a message 
            types: ok, error
        */}
        {/* <div className="input__message">
          <img src={imageSrc} alt="" />

          <p>Hubo un error</p>
        </div> */}
      </div>
    )
  }

  // Color input
  if (type === "color") {
    return (
      <div className="input">
        <div className="input__field --color">
          <input className={`input__color`} type="checkbox" name={name} required={isRequired ? true : false} value={value} id={id} onChange={changed} />
          <label htmlFor={name} className={`input__color__label --${color}`}></label>
        </div>

        {/* Message box to display a message 
          types: ok, error
      */}
        {/* <div className="input__message">
        <img src={imageSrc} alt="" />

        <p>Hubo un error</p>
      </div> */}
      </div>
    )
  }
}

export default InputCheckBox